import i18n from '@nextroll/ar-i18n';

const PasswordResetSaveConfirmation = () => (
    <div className='eh-card-2 eh-feedback-password-reset-save'>
        <div className='eh-card-header'>
            <p className='eh-card-header-title'>
                <i className='fas ar-icon-success' />
                <span>
                    {i18n.gettext(
                        'Your Password has been successfully changed.'
                    )}
                </span>
            </p>
        </div>
        <div className='eh-card-body'>
            <p>
                {i18n.gettext(
                    'You have been automatically signed in using your new password.'
                )}
            </p>
        </div>
        <div className='eh-card-footer'>
            <a
                className='btn btn-primary'
                href='/account/centralredirect'
                rel='noreferrer'
            >
                {i18n.gettext('Continue to Account')}
            </a>
        </div>
    </div>
);

export default PasswordResetSaveConfirmation;
